import { connect } from 'react-redux'
import FileUploadModal from './FileUploadModal'
import { uploadFile, uploadAudio, uploadAudioForPorta } from '../Files.actions'

const mapStateToProps = ({ files }) => {
  const name = 'fileUploadModal'
  const file = files[name] || {}
  return {
    loading: file.loading || false,
    name,
  }
}

const dispatchToProps = {
  uploadFile,
  uploadAudio,
  uploadAudioForPorta,
}

export default connect(mapStateToProps, dispatchToProps)(FileUploadModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileUploadModal/FileUploadModal.container.js